// VFX: Neon Glow Pulse
// Category: overlays · Tags: neon, glow, cyberpunk, pulse, night
// Animated neon tube glow with flicker, bloom and color cycling — cyberpunk overlay.
import { AbsoluteFill, useCurrentFrame, useVideoConfig, interpolateColors, random } from "remotion";
import React from "react";

export default function NeonGlowPulse() {
  const frame = useCurrentFrame();
  const { durationInFrames } = useVideoConfig();
  const t = (frame % durationInFrames) / durationInFrames;
  const color = interpolateColors(t, [0, 0.5, 1], ["#a855f7", "#06b6d4", "#a855f7"]);
  const pulse = 0.6 + Math.sin(frame * 0.18) * 0.4;
  const flickerChance = random(`flicker-${Math.floor(frame / 3)}`);
  const flicker = flickerChance < 0.08 ? 0.4 : 1;
  return (
    <AbsoluteFill style={{ background: "#050508", justifyContent: "center", alignItems: "center", overflow: "hidden" }}>
      <div style={{
        width: 6, height: "70%",
        background: color,
        boxShadow: `0 0 ${20 * pulse}px ${color}, 0 0 ${60 * pulse}px ${color}, 0 0 ${120 * pulse}px ${color}88`,
        opacity: flicker,
        borderRadius: 4,
      }} />
      <div style={{
        position: "absolute",
        width: "80%", height: 6,
        top: "30%",
        background: color,
        boxShadow: `0 0 ${20 * pulse}px ${color}, 0 0 ${60 * pulse}px ${color}cc`,
        opacity: flicker * 0.7,
        borderRadius: 4,
        transform: `rotate(${Math.sin(frame * 0.05) * 2}deg)`,
      }} />
      <div style={{
        position: "absolute", inset: 0,
        background: `radial-gradient(circle at 50% 50%, ${color}22 0%, transparent 60%)`,
        opacity: pulse,
      }} />
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
